<template>
	<module class="m-list" :title="title">
		<c-empty v-if="emptyState" style="height: 100%;"></c-empty>
		<div v-else ref="table" class="table flex-column" @mouseenter="stopAutoScroll" @mouseleave="activeScroll ? autoScrollHandle() : ''">
			<div ref="thead" class="thead">
				<div class="tr flex">
					<template v-for="(col, i) in columnList">
						<div v-if="col.is_display == 1" :key="i" class="th flex-grow" :style="{'flex-grow': col.width, 'width': col.width / 100 + 'rem'}">
							<span>{{col.field_title}}</span>
							<div class="drag" @mousedown="dragHandle($event, col)"></div>
						</div>
					</template>
				</div>
			</div>
			<div class="flex-grow">
				<c-scroll ref="scroll" :scroll-x="!autoScroll" bar-color="rgba(255,255,255,.3)" @scroll="scrollHandle">
					<div ref="tbody" class="tbody" :scroll="scrollState" :style="{'transform': `translate(0,-${scrollTop})`}">
						<div v-for="(data, i) in dataList" :key="i" ref="tr" class="tr flex">
							<template v-for="(col, j) in columnList">
								<div v-if="col.is_display == 1" :key="j" class="td flex-center-cross flex-grow" :style="{'flex-grow': col.width, 'width': col.width / 100 + 'rem'}">
									<div class="flex-grow">
										<list-cell :work-type="workType" :name="col.field_code" :data="data" :custom-config="col.is_custom == 1 ? col.config_json : undefined"></list-cell>
									</div>
								</div>
							</template>
						</div>
					</div>
				</c-scroll>
			</div>
			<div v-if="widthResizePosition"  class="drag-line" :style="{'left': widthResizePosition + 'px'}"></div>
		</div>
	</module>
</template>

<script>
	import module from './digital_module.vue'
	import listCell from './digital_list_cell.vue'
	import {throttle} from '@deanwu/vue-component-library'

	export default {
		components: {
			module,
			listCell
		},

		props: {
			id: [Number, String]
		},

		data() {
			return {
				title: '',
				workType: 0,
				viewId: 0,
				columnList: [],
				dataList: [],
				autoScroll: false,
				autoSpan: 0,
				activeScroll: false,
				emptyState: false,

				widthResizePosition: 0,

				scrollIndex: 0,
				scrollTop: 0,
				scrollState: false
			}
		},

		watch: {
			scrollIndex(val) {
				let $tr = this.$refs.tr && this.$refs.tr[val];
				this.scrollTop = $tr ? $tr.getBoundingClientRect().top - this.$refs.tbody.getBoundingClientRect().top + 'px' : 0;
			}
		},
		
		mounted() {
			this.update();
		},
		
		beforeDestroy() {
			clearTimeout(this._updateTimer);
		},

		methods: {
			update() {
				this.request({
					url: '/digital/getData',
					data: {
						digital_id: this.$parent.digitalId,
						module_id: this.id
					},
					success: data => {
						this.title = data.childModuleList[0].title;
						this.workType = data.childModuleList[0].work_type_id;
						this.viewId = data.childModuleList[0].view_id;
						this.columnList = data.childModuleList[0].header;
						this.dataList = data.childModuleList[0].data;
						this.dataList.forEach(item => {
							item._timestamp = new Date().getTime();
						});
						this.emptyState = !this.dataList.length;
						this.autoScroll = data.childModuleList[0].auto_scroll == 1;
						this.autoSpan = data.childModuleList[0].auto_span || 3;
						this.$nextTick(() => {
							clearTimeout(this._scrollTimer);
							this.scrollState = false;
							if (this.autoScroll && this.$refs.tbody.clientHeight > this.$refs.scroll.$el.clientHeight) {
								this.dataList = this.dataList.concat(this.dataList);
								this.activeScroll = true;
								this.$nextTick(this.autoScrollHandle);
							} else {
								this.$nextTick(() => {
									this.scrollIndex = 0;
								});
							}
						});
						this._updateTimer = setTimeout(this.update, data.childModuleList[0].refresh_time * 1000 || 300000);
					},
					fail: () => {
						this._updateTimer = setTimeout(this.update, 300000);
					}
				});
			},
			
			dragHandle(e, col) {
				let startLeft = e.target.getBoundingClientRect().left - this.$refs.table.getBoundingClientRect().left;
				let startX = e.clientX, resize = 0;
				let min = 20 - col.width;
				this.widthResizePosition = startLeft;

				const move = throttle(e => {
					resize = e.clientX - startX;
					this.widthResizePosition = startLeft + resize;
				}, 20, false);

				const moveEnd = () => {
					col.width += Math.max(min, resize);
					document.removeEventListener('mousemove', move);
					document.removeEventListener('mouseup', moveEnd);
					this.widthResizePosition = 0;
					this.request({
						url: '/sys_user_view/edit_field',
						data: {
							view_id: this.viewId,
							dimension_id: 0,
							field_list: this.columnList.map(item => {
								return {
									field_id: item.field_id,
									width: item.width,
									is_display: item.is_display,
									is_lock: item.is_lock
								}
							})
						}
					})
				}
				
				document.addEventListener('mousemove', move);
				document.addEventListener('mouseup', moveEnd);
			},

			scrollHandle(e) {
				this.$refs.thead.scrollLeft = e.x;
			},

			autoScrollHandle() {
				this.$nextTick(() => {
					if (this.scrollIndex >= this.dataList.length / 2) {
						this.scrollIndex = 0;
					}
				});

				!function loop() {
					this._scrollTimer = setTimeout(() => {
						this.scrollState = true;
						this.$nextTick(() => {
							this.scrollIndex++;
						});
						setTimeout(() => {
							this.scrollState = false;
							this.$nextTick(() => {
								if (this.scrollIndex >= this.dataList.length / 2) {
									this.scrollIndex = 0;
								}
							});
						}, 500);
						loop.call(this);
					}, this.autoSpan * 1000);
				}.call(this)
			},

			stopAutoScroll() {
				clearTimeout(this._scrollTimer);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-list {
		.table {
			position: relative;
			height: 100%;

			.thead {
				margin-bottom: .06rem;
				overflow: hidden;

				.tr {
					float: left;
					min-width: 100%;

					.th {
						position: relative;
						box-sizing: border-box;
						padding: .12rem .1rem;
						line-height: .16rem;
						font-size: .16rem;
						white-space: nowrap;
						color: #00FFFF;
						background: #092341;

						&:nth-child(n+2) {
							margin-left: .03rem;
						}
					}
				}
			}

			.tbody {
				overflow: hidden;

				&[scroll] {
					transition: transform .5s ease;
				}

				.tr {
					float: left;
					min-width: 100%;
					background: #092341;

					&:nth-child(n+2) {
						margin-top: .04rem;
					}

					.td {
						box-sizing: border-box;
						min-height: .4rem;
						padding: 0 .1rem;
						line-height: .18rem;
						font-size: .16rem;
						word-break: break-word;
						color: #fff;

						&:nth-child(n+2) {
							margin-left: .03rem;
						}

						>>> .process-rate {
							.item {
								margin-top: .08rem;

								&:nth-child(1) {
									margin-left: .22rem;
								}
								&:nth-last-child(1) {
									margin-right: .22rem;
								}
							}
							
							.circle {
								color: #fff !important;
								background: none !important;
							}

							.line {
								min-width: .36rem;
								margin-top: .23rem;
							}

							.tag {
								top: -.02rem;
								padding: 0 .04rem;
								line-height: .12rem;
								font-size: .1rem;
							}

							.state {
								top: .21rem !important;
								width: .12rem !important;
								height: .12rem !important;
								font-size: .1rem !important;
							}

							p {
								width: .3rem !important;
								margin-top: .04rem !important;
								font-size: .15rem !important;
								white-space: nowrap;
								color: #fff !important;

								span {
									min-width: 5em;
								}
							}

							.__bar-is-horizontal {
								background: rgba(255,255,255,.2) !important;
							}
						}

						>>> .c-progress-circle {
							width: .3rem !important;
							height: .3rem !important;

							&-text {
								span {
									font-size: .1rem !important;
									color: #fff !important;
								}
							}
						}

						>>> .c-progress-line-text {
							font-size: .12rem !important;
						}

						>>> .c-tags {
							gap: .05rem;

							.item {
								padding: 0 .06rem;
								line-height: .22rem;
								font-size: .12rem;
							}
						}

						>>> .c-file-list {
							gap: .06rem;

							.c-file-media {
								width: .32rem;
								height: .32rem;
								border-color: #1A3452;
								background: #1A3452;
							}
						}
					}
				}
			}

			.drag {
				position: absolute;
				left: 100%;
				top: 0;
				bottom: 0;
				width: .06rem;
				margin-left: -.03rem;
				cursor: col-resize;

				&-line {
					z-index: 10;
					position: absolute;
					top: 0;
					bottom: 0;
					width: .03rem;
					background: #0ff;
					cursor: col-resize;
				}
			}
		}
	}
</style>
